module.exports = "<div  *ngIf=\"visible\" class=\"dialog\">\r\n  <ng-content></ng-content>\r\n  <button *ngIf=\"closable\" (click)=\"close()\" aria-label=\"Close\" class=\"dialog__close-btn\">X</button>\r\n</div>\r\n<div *ngIf=\"visible\" class=\"overlaydialog\" (click)=\"close()\"></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/component/dialog-box/dialog.component.html
// module id = ./src/app/shared/component/dialog-box/dialog.component.html
// module chunks = main